import { createReducer, on } from "@ngrx/store";
import { ResultadoPesquisaJornalOutputDto } from "src/app/domain/DTOs/output/jornal/resultado-pesquisa-jornal.output.dto";
import { pesquisarJornalPaginado, pesquisarJornalPaginadoCatchError, pesquisarJornalPaginadoFailure, pesquisarJornalPaginadoFinish, pesquisarJornalPaginadoSuccess } from "../../actions/Pesquisa/pesquisar-jornal-paginado.action";
import { EstruturaRetornoDadosPaginadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto";

export interface PesquisarJornalPaginadoState {
    response: EstruturaRetornoDadosPaginadosOutputDto<ResultadoPesquisaJornalOutputDto[]> | null;
    error: string[] | null;
}

export const initialState: PesquisarJornalPaginadoState = {
    response: null,
    error: null,
};

export const PesquisarJornalPaginadoReducer = createReducer(
    initialState,
    on(pesquisarJornalPaginado, state => ({ ...state, error: null })),
    on(pesquisarJornalPaginadoSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(pesquisarJornalPaginadoFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(pesquisarJornalPaginadoCatchError, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(pesquisarJornalPaginadoFinish, state => ({ ...state, response: null, error: null })),
);
